import axios from 'axios';
import {clearLoadingCache} from '@src/helpers/LoadingCache';
import { handleStaffSessionExpired } from '@src/helpers/StaffSession';
import { generateUniqueID } from '@src/helpers/Helpers';
import { getStorage, STORAGE_TAG_TOKEN } from '@src/helpers/StorageHelper';

const api = axios.create({
 adapter: axios.getAdapter('xhr'),
	baseURL: '',
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'X-Request-ID': generateUniqueID(),
	},
});

// Add request interceptor for auth token
api.interceptors.request.use(
	(config) => {
  if(config.method && config.method.toLowerCase()!=='get' && /\/(auth|templates|users|settings)\//.test(config.url || ''))clearLoadingCache();
		const token = getStorage().getItem(STORAGE_TAG_TOKEN);
		if (token) {
			config.headers.Authorization = `Token ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

api.interceptors.response.use(response => response, error => {
 if(error.response?.status===401 || error.response?.status===403)clearLoadingCache();
 handleStaffSessionExpired(error.response?.status);
 return Promise.reject(error);
});

export default api;
